import styled, { css, keyframes } from 'styled-components';

import { theme } from '../../../common/ui/theme';

const expand = keyframes`
    from {
        transform: scaleX(0);
    }
    to {
        transform: scaleX(1);
    }
`;

const activeStyles = css`
    color: ${theme.colors.accent.foreground};
    position: relative;

    &:hover {
        background-color: ${theme.colors.accent.background};
    }

    &::after {
        content: '';
        position: absolute;
        bottom: -8px;
        left: 8px;
        height: 2px;
        width: calc(100% - 16px);
        background-color: ${theme.colors.accent.emphasis};
        border-radius: 10px;
        transform-origin: center;
        transform: translateX(-50%) scaleX(0);
        animation: ${expand} 150ms ease forwards;
    }
`;

interface TabProps {
    active?: boolean;
}

export const Tab = styled.button<TabProps>`
    display: flex;
    align-items: baseline;
    gap: ${theme.space[4]};
    border: none;
    border-radius: ${theme.radii[8]};
    font-weight: ${theme.fontWeights[500]};
    font-size: ${theme.fontSizes[14]};
    line-height: 24px;
    padding: 0 ${theme.space[8]};
    color: ${theme.colors.foreground.default};

    &:hover {
        background-color: ${theme.colors.background.inset};
    }

    ${(props) => (props.active ? activeStyles : null)}
`;
